<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>
            Informações da Rodada
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-4"
            @click="$router.push('/rodadas')"
            >Voltar</v-btn
          >
        </v-app-bar>

        <v-form ref="form">
          <v-container fluid class="pb-0" style="pointer-events: none">
            <v-row dense>
              <v-col sm="9">
                <v-text-field
                  label="Nome"
                  ref="nome"
                  v-model="rodada.nome"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Início"
                  ref="data_inicio"
                  v-model="rodada.data_inicio"
                  readonly
                ></as-date-picker-menu>
              </v-col>
              <v-col sm="9">
                <v-text-field
                  label="Local"
                  ref="local"
                  v-model="rodada.local"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Fim"
                  ref="data_fim"
                  v-model="rodada.data_fim"
                  readonly
                ></as-date-picker-menu>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Veiculação"
                  ref="data_veiculacao"
                  readonly
                  v-model="rodada.data_veiculacao"
                ></as-date-picker-menu>
              </v-col>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Limite"
                  ref="data_limite"
                  readonly
                  v-model="rodada.data_limite"
                ></as-date-picker-menu>
              </v-col>
              <v-col sm="3" cols="6">
                <v-text-field
                  label="Estado"
                  ref="estado"
                  v-model="rodada.estado_nome"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="6">
                <v-text-field
                  label="Cidade"
                  ref="cidade"
                  v-model="rodada.cidade_nome"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>

      <v-card v-show="!loading" class="mt-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Representantes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="tooglePesquisa"
          >
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn
            depressed
            color="primary lighten-4"
            class="ml-2"
            @click="abriDialogoRepresentantes"
            v-if="user.tipo == 'administrador' && podeEditar(rodada.data_fim)"
            >Adicionar</v-btn
          >
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="representantes_rodada"
          :loading="loading"
          :items-per-page="30"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
        >
          <template
            v-slot:item.acoes="{ item }"
            v-if="user.tipo == 'administrador' && podeEditar(rodada.data_fim)"
          >
            <td>
              <v-btn icon text @click="abrirdialogoExcluir(item)">
                <v-icon>close</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoRepresentantes"
        title="Seleção de Representantes"
        max-width="1200px"
        altura="525px"
      >
        <section v-show="!loading_adicionar">
          <v-row dense>
            <v-col pa-2>
              <v-text-field
                ref="pesquisa2"
                label="Pesquisa"
                v-model="pesquisa2"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col pa-2>
              <v-card>
                <v-data-table
                  :search="pesquisa2"
                  :headers="headers"
                  :items="representantes"
                  hide-default-footer
                  :loading="loading"
                  no-data-text="Sem registros"
                  no-results-text="Sem registros"
                  loading-text="Carregando dados..."
                >
                  <template v-slot:item.acoes="{ item }">
                    <td>
                      <v-btn
                        text
                        icon
                        @click="adicionarRepresentante(item)"
                        :loading="item.adicionando"
                        :disabled="item.adicionando"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </section>

        <v-row v-show="loading_adicionar" class="justify-center align-center">
          <v-progress-circular
            indeterminate
            size="50"
            width="3"
            color="primary"
          ></v-progress-circular>
        </v-row>
      </as-dialogo>

      <as-dialogo
        ref="dialogoExcluir"
        title="Exclusão de Representante"
        max-width="728px"
        hideCloseButton
      >
        <v-label
          >Tem certeza que deseja remover esse representante dessa
          rodada?</v-label
        >
        <div class="pt-8" style="display: flex; justify-content: flex-end;">
          <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="excluirRepresentante"
            :loading="loading_excluir"
            :disabled="loading_excluir"
            >Excluir</v-btn
          >
        </div>
      </as-dialogo>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular
          indeterminate
          size="50"
          width="3"
          color="primary"
        ></v-progress-circular>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Services from "../../services/services.js";
import ServiceRodadas from "../../services/rodadas.js";

export default {
  name: "RepresentantesSelecao",
  data() {
    return {
      loading: false,
      loading_adicionar: false,
      loading_excluir: false,
      exibirPesquisa: false,
      pesquisa: "",
      pesquisa2: "",
      rodada: {
        nome: "",
        local: "",
        data_inicio: "",
        data_fim: "",
        data_veiculacao: "",
        estado_nome: "",
        cidade_nome: "",
      },
      estados: [],
      cidade: [],
      representantes_rodada: [],
      headers: [],
      representantes: [],
      adicionando: false,
      representante: {},
      user: {},
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.tipo == "administrador") {
      this.headers = [
        { text: "Nome", value: "nome_fantasia", width: "70%" },
        { text: "Cidade / Estado", value: "cidade_estado", width: "25%" },
        {
          text: "",
          value: "acoes",
          sortable: false,
          width: "5%",
          align: "center",
        },
      ];
    } else if (this.user.tipo == "representante") {
      this.headers = [
        { text: "Nome", value: "nome_fantasia", width: "70%" },
        {
          text: "Cidade/Estado",
          value: "cidade_estado",
          width: "30%",
          align: "right",
        },
      ];
    }
    this.abrir();
  },
  methods: {
    podeEditar(dataFim) {
      return new Date(dataFim) > new Date();
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async abrir() {
      try {
        this.loading = true;
        let response_rodada = await ServiceRodadas.abrir(
          this.$route.params.rodada_id
        );
        this.rodada = response_rodada.data.rodada;

        let response_representantes_rodada = await ServiceRodadas.carregarRepresentantesRodada(
          this.$route.params.rodada_id
        );
        this.representantes_rodada =
          response_representantes_rodada.data.representantes;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar rodada", error);
      } finally {
        this.loading = false;
      }
    },
    async abriDialogoRepresentantes() {
      this.$refs.dialogoRepresentantes.abrir();
      try {
        this.loading_adicionar = true;
        this.pesquisa2 = "";
        let representantes_lista = await ServiceRodadas.carregarRepresentantes(
          this.$route.params.rodada_id
        );
        this.representantes = representantes_lista.data.representantes;
        setTimeout(() => {
          this.$refs.pesquisa2.focus();
        }, 0);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar representantes", error);
      } finally {
        this.loading_adicionar = false;
      }
    },
    async adicionarRepresentante(representante) {
      try {
        this.$set(representante, "adicionando", true);
        await ServiceRodadas.salvarRepresentante(
          this.$route.params.rodada_id,
          representante.id
        );
        this.$eventbus.notificar(
          representante.nome_fantasia + " adicionado a rodada com sucesso"
        );

        let response_representantes_rodada = await ServiceRodadas.carregarRepresentantesRodada(
          this.$route.params.rodada_id
        );
        this.representantes_rodada =
          response_representantes_rodada.data.representantes;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao salvar o representante", error);
      } finally {
        this.$set(representante, "adicionando", false);

        let representantes_lista = await ServiceRodadas.carregarRepresentantes(
          this.$route.params.rodada_id
        );
        this.representantes = representantes_lista.data.representantes;
      }
    },
    abrirdialogoExcluir(representante) {
      this.representante = representante;
      this.$refs.dialogoExcluir.abrir();
    },
    async excluirRepresentante() {
      try {
        this.loading_excluir = true;

        await ServiceRodadas.excluirRepresentante(
          this.$route.params.rodada_id,
          this.representante.id
        );
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir o representante", error);
      } finally {
        let response_representantes_rodada = await ServiceRodadas.carregarRepresentantesRodada(
          this.$route.params.rodada_id
        );
        this.representantes_rodada =
          response_representantes_rodada.data.representantes;

        this.loading_excluir = false;
        this.$refs.dialogoExcluir.fechar();
        this.$eventbus.notificar(
          this.representante.nome_fantasia + " removido da rodada com sucesso"
        );
        this.representante = {};
      }
    },
    async importarRepresentantes() {
      try {
        let response = await ServiceRodadas.importarRepresentantes(
          this.$route.params.rodada_id
        );
        this.$eventbus.notificar("Representantes importados com sucesso");
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao importar representantes");
      }
    },
  },
};
</script>

<style></style>
